import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const ColorPickerWrapper = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 7px;
  padding: 12px;
  border: 1px solid ${colors.lightGrey};
  border-radius: 3px;
`

export const ColorPickerItem = styled('div')<{ $color?: string; $size?: string; $isSelected?: boolean }>`
  border-radius: 50%;
  position: relative;

  ${({ $color, $size, $isSelected }) => `
    background: ${$color};
    width: ${$size};
    height: ${$size};
    cursor: pointer;
    &:after {
      background: none;
      border: 1px solid ${colors.white};
      content: '';
      display: ${$isSelected ? 'block' : 'none'};
      position: absolute;
      top: 2px;
      left: 2px;
      right: 2px;
      bottom: 2px;
      pointer-events: none;
      border-radius: 50%;
    }
  `}
  &:hover {
    &:before {
      background: none;
      border: 2px solid #f2f2f2;
      content: '';
      display: block;
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      pointer-events: none;
      border-radius: 50%;
    }
  }
`
